<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/yearInList')">年度考核统计</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='代理信息'>
            <el-input
              style="width:200px"
              v-model="filters.userInfo"
              placeholder="请输入姓名或者手机号"
            >

            </el-input>
          </el-form-item>

          <el-form-item label='剩余天数'>
            <el-input
              style="width:200px"
              v-model="filters.lastDay"
              placeholder="请输入剩余天数"
            >

            </el-input>
          </el-form-item>

          <!-- <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item> -->
          <el-form-item label='代理级别'>
            <el-select
              v-model="filters.roleType"
              clearable
            >
              <el-option
                label="vip"
                value="0"
              ></el-option>

              <el-option
                label="高级"
                value="1"
              ></el-option>

              <el-option
                label="优秀高级"
                value="1.05"
              ></el-option>

              <el-option
                label="市代"
                value="2"
              ></el-option>
              <el-option
                label="省代"
                value="3"
              ></el-option>
              <el-option
                label="CEO"
                value="4"
              ></el-option>
              <el-option
                label="总经销商"
                value="5"
              ></el-option>


            </el-select>
          </el-form-item>


          <el-form-item label="状态">
            <el-select
              v-model="filters.finishStatus"
              clearable
            >
              <el-option
                label="已完成"
                value="1"
              ></el-option>
              <el-option
                label="未完成"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >


          <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column
            prop="max_money"
            label="考核金额"
          >
          <template slot-scope="scope">
            {{scope.row.in_money}}/{{scope.row.max_money}}
          </template>
          </el-table-column>


          <el-table-column
            prop="role_type"
            :formatter="formatterRoleType"
            label="代理身份"
          >
          </el-table-column>

          <el-table-column
            prop="begin_day_ot"
            label="开始日期"
          >
          </el-table-column>

          <el-table-column
            prop="end_day_ot"
            label="结束日期"
          >
          </el-table-column>

          <el-table-column
            prop="last_day"
            label="剩余天数"
          >
          </el-table-column>


          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.in_money >= scope.row.max_money"
                type="success"
                disable-transitions
              >已完成 </el-tag>
              <el-tag
                v-if="scope.row.in_money < scope.row.max_money"
                disable-transitions
              >未完成</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >通过</el-button>
                <el-button
                  @click="upHouseStatus(scope.row,3)"
                  type="text"
                  size="small"
                >拒绝</el-button>
              </template>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "checkStockList",
  created() {},

  data() {
    return {
      totalMoney: 0,
      listLoading: false,
      picList: [],
      filters: {
        lastDay:null,
        finishStatus: null,
        startTime: null,
        userInfo: null,
        roleType: null,
        endTime: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word =  "康减系列市代";
      } else if (row.role_type == 2.1) {
        word =  "康减系列省代";
      } else if (row.role_type == 3.1) {
        word =  "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + '-' + '特殊';
      }
      return word;
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/year_in_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.finishStatus) {
        url = url + "&finishStatus=" + that.filters.finishStatus;
      }
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      if (that.filters.userInfo) {
        url = url + "&userInfo=" + that.filters.userInfo;
      }
      if (that.filters.lastDay) {
        url = url + "&lastDay=" + that.filters.lastDay;
      }
      top.location.href = url;
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 3
            };
            API.check_add_user_stock(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  console.error(err);
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 2
            };
            API.check_add_user_stock(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.finishStatus) {
        params.finishStatus = that.filters.finishStatus;
      }
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.userInfo) {
        params.userInfo = that.filters.userInfo;
      }
      if (that.filters.startTime) {
        params.beginTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.lastDay) {
        params.lastDay = that.filters.lastDay;
      }

      that.listLoading = true;
      API.year_in_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.totalMoney = result.result.data;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].begin_day_ot = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].begin_day)),
                      "yyyy-MM-dd"
                    );
                  result.result.list[i].end_day_ot = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].end_day)),
                      "yyyy-MM-dd"
                    );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/good/yearInList.vue